/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_ArbolOrganizacion as ArbolOrganizacion,
  rec_DetalleUnidad as DetalleUnidad,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_lt as lt,
} from "../../runtime/index.jsx";
export function Organizacion() {
  let e = (0, ReactCompiler.c)(2),
    { id: t } = lt(),
    n;
  return (
    e[0] === t
      ? (n = e[1])
      : ((n = t ? <DetalleUnidad key={t} id={t} /> : <ArbolOrganizacion />),
        (e[0] = t),
        (e[1] = n)),
    n
  );
}
